"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTXOBaseAdapter = void 0;
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const types_1 = require("@shapeshiftoss/types");
const multicoin_address_validator_1 = __importDefault(require("multicoin-address-validator"));
const ErrorHandler_1 = require("../error/ErrorHandler");
const utils_1 = require("../utils");
const bignumber_1 = require("../utils/bignumber");
/**
 * Base chain adapter for all UTXO chains. When extending please add your ChainType to the
 * UTXOChainTypes. For example:
 *
 * `export type UTXOChainTypes = ChainTypes.Bitcoin | ChainTypes.Litecoin`
 */
class UTXOBaseAdapter {
    constructor(args) {
        this.providers = args.providers;
    }
    /* public methods */
    getChainId() {
        return this.chainId;
    }
    getAssetId() {
        return this.assetId;
    }
    async getAccount(pubkey) {
        if (!pubkey) {
            return (0, ErrorHandler_1.ErrorHandler)('UTXOBaseAdapter: pubkey parameter is not defined');
        }
        try {
            const { data } = await this.providers.http.getAccount({ pubkey });
            const balance = (0, bignumber_1.bnOrZero)(data.balance).plus((0, bignumber_1.bnOrZero)(data.unconfirmedBalance));
            return {
                balance: balance.toString(),
                chain: this.getType(),
                chainId: this.chainId,
                assetId: this.assetId,
                chainSpecific: {
                    addresses: data.addresses,
                    nextChangeAddressIndex: data.nextChangeAddressIndex,
                    nextReceiveAddressIndex: data.nextReceiveAddressIndex
                },
                pubkey: data.pubkey
            };
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async broadcastTransaction(hex) {
        const { data } = await this.providers.http.sendTx({
            sendTxBody: { hex }
        });
        return data;
    }
    async validateAddress(address) {
        const isValidAddress = multicoin_address_validator_1.default.validate(address, this.getType());
        if (isValidAddress)
            return { valid: true, result: types_1.chainAdapters.ValidAddressResultType.Valid };
        return { valid: false, result: types_1.chainAdapters.ValidAddressResultType.Invalid };
    }
    /* protected / private methods */
    async getPublicKey(wallet, bip44Params, accountType) {
        const path = (0, utils_1.toRootDerivationPath)(bip44Params);
        const publicKeys = await wallet.getPublicKeys([
            {
                coin: this.coinName,
                addressNList: (0, hdwallet_core_1.bip32ToAddressNList)(path),
                curve: 'secp256k1',
                scriptType: utils_1.accountTypeToScriptType[accountType]
            }
        ]);
        if (!(publicKeys === null || publicKeys === void 0 ? void 0 : publicKeys[0]))
            throw new Error("couldn't get public key");
        if (accountType) {
            return { xpub: (0, utils_1.convertXpubVersion)(publicKeys[0].xpub, accountType) };
        }
        return publicKeys[0];
    }
}
exports.UTXOBaseAdapter = UTXOBaseAdapter;
